import { createApi } from '@reduxjs/toolkit/query/react'
import customFetchBase from '../services/CustomFetchBase'

/**
 * API slice for fetching the list of purchase requests.
 */
export const purchaseRequestsListApi = createApi({
    reducerPath: 'purchaseRequestsListApi',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({
        /**
         * Mutation to fetch a paginated list of purchase requests.
         *
         * @param {Object} params - Query parameters for fetching purchase requests.
         * @param {number} params.page - The page number for pagination.
         * @param {number} params.limit - The number of items per page.
         * @returns {Promise<any>} The response containing the list of purchase requests.
         */
        purchaseRequestsList: builder.mutation({
            query: ({ page, limit }) => ({
                url: `/purchaseRequestsList?page=${page}&limit=${limit}`,
                method: 'GET'
            })
        })
    })
})

/**
 * Auto-generated hook for fetching purchase requests.
 */
export const { usePurchaseRequestsListMutation } = purchaseRequestsListApi
